import { axiosInstance } from '@configs/axios/axiosInstance';

import type { AeContact } from './getContacts.types';

export async function getContacts(organizationId: string): Promise<AeContact> {
  const { data } = await axiosInstance.get<AeContact>(
    `/users/organizations/${organizationId}/contacts`,
    {
      headers: { 'X-Organization-ID': organizationId },
    }
  );
  return data;
}
